import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import * as R from 'ramda'
import Assets from 'app/configs/assetConfigs'

export const useAppName = () => {
  return useSelector(
    R.pathOr('MessageSpring', ['place', 'partner', 'partnerName']),
  )
}

export const useAppLogo = () => {
  const partnerLogo = useSelector(R.path(['place', 'partner', 'logo']))
  return {
    logo: partnerLogo || Assets.logo,
    logoRev: partnerLogo || Assets.logoRev,
    banner: partnerLogo || Assets.banner,
    bannerRev: partnerLogo || Assets.bannerRev,
    favicon: partnerLogo || Assets.favicon,
  }
}

export const PartnerBrowerSetup = ({ children }) => {
  const appName = useAppName()
  const { favicon } = useAppLogo()
  useEffect(() => {
    if (document && appName) {
      document.title = `${appName} - Your Communication Dashboard`
    }

    const faviconElement = document.querySelector('#favicon')
    if (faviconElement && favicon) {
      faviconElement.setAttribute('href', favicon)
    }
  }, [appName, favicon])

  return children
}
